import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class UnreadCountDto {
  @Field(t => Int)
  author!: number

  @Field(t => Int)
  reviewer!: number
}
